module.exports = __webpack_public_path__ + "static/fonts/PingFang-Medium.a89d0fc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/PingFang-Medium.ttf
// module id = NZQ+
// module chunks = 21